"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.test = exports.domainRegistrySol = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.domainRegistrySol = require("./DomainRegistry.sol");
exports.test = require("./test");
//# sourceMappingURL=index.js.map